import { ModalSize } from 'ngx-fomantic-ui';

export interface IConfirmModalContext {
    headerIcon?: string;
    header?: string;
    message?: string;
  }
  
  export interface IModalOptions {
    size?: ModalSize;
    transitionDuration?: number;
    closable?: boolean;
    isBasic?: boolean;
  }
  